import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Quién facilita el entrenamiento?',
    a: 'El entrenamiento es facilitado por el equipo certificado de TRILOGY — coaches con más de 10 años de experiencia acompañando personas en Latinoamérica y Estados Unidos, entrenados bajo la metodología de su fundador Jaime Nieto.'
  }, {
    q: '¿Necesito experiencia previa en coaching o desarrollo personal?',
    a: 'No. La Noche de Impacto está diseñada para cualquier persona que quiera vivir una transformación real, independientemente de su experiencia previa.'
  }, {
    q: '¿Es seguro romper una tabla?',
    a: 'Completamente. El equipo de TRILOGY guía el proceso paso a paso. Miles de personas lo han hecho antes que tú — incluyendo personas que nunca imaginaron que podían. Eso es exactamente el punto.'
  }, {
    q: '¿Dónde exactamente es el evento?',
    a: 'En Miami, Florida. La dirección exacta se envía por email al completar tu registro.'
  }, {
    q: '¿Qué pasa si no puedo asistir?',
    a: 'Escríbenos antes del evento y lo resolvemos. Tu transformación no puede esperar — pero entendemos que la vida pasa.'
  }, {
    q: '¿Por qué solo $5?',
    a: 'Este entrenamiento tiene un valor de $50. En honor al Mes de la Mujer lo abrimos con un 90% de descuento — porque no queremos que ningún límite económico te impida estar ahí. Esta oferta termina el 15 de marzo.'
  }, {
    q: '¿Puedo llevar a alguien?',
    a: 'Sí — y te lo recomendamos. Vivir esto con alguien cercano multiplica el impacto. Cada persona debe registrarse por separado.'
  }, {
    q: '¿Qué sigue después de la Noche de Impacto?',
    a: 'La Noche de Impacto es el primer paso. Si quieres ir más profundo, al final del evento te presentaremos el siguiente nivel de transformación con Trilogy. Sin presión. Solo si estás listo/a.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-24 px-4 bg-[#1a0a2e] text-white" data-id="element-32">
      <div className="max-w-3xl mx-auto" data-id="element-33">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-[#F5A623]" data-id="element-34">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-35">
          {faqs.map((faq, index) => <div key={index} className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden transition-all duration-300" data-id="element-36">
              <button onClick={() => toggleFAQ(index)} className="w-full text-left px-6 py-5 flex items-center justify-between focus:outline-none" aria-expanded={openIndex === index} data-id="element-37">
                <span className="text-lg font-bold flex gap-3" data-id="element-38">
                  <span className="text-[#F5A623]" data-id="element-39">❓</span>
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-gray-400 transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-40" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-41">
                <p className="text-gray-300 pl-9 leading-relaxed" data-id="element-42">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}